module.exports = __webpack_public_path__ + "static/media/hall.7335db08.jpg";